<template>
  <el-drawer
    :visible="Visible"
    size="70%"
    title="Reporte balance de Tarjeta"
    @close="$emit('VisibleFalse', false)"
  >
    <el-row></el-row>

    <el-row type="flex" justify="end">
      <el-col :span="10" :offset="1">
        <el-select
          size="large"
          v-model="Valor"
          filterable
          clearable
          placeholder="Buscar Ultimos Movimientos"
          @change="ChangeDays()"
          class="supliers_select"
        >
          <el-option
            v-for="item in Valores"
            :key="item.value"
            :label="item.Label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row>
      <el-table
        class="Table"
        :data="tableData1"
        style="width: 100%"
        v-loading="Loading"
      >
        <el-table-column prop="Fecha" label="Fecha" width="100">
          <template slot-scope="scope">
            <label :type="scope.row.Fecha">
              {{ new Date(scope.row.Fecha).toLocaleDateString() }}
            </label>
          </template>
        </el-table-column>

        <el-table-column prop="Descripcion" label="Descripcion" width="190">
        </el-table-column>

        <el-table-column prop="Sucursal" label="Sucursal" width="250">
        </el-table-column>

        <el-table-column prop="Recarga" label="Recargas" width="100">
          <template slot-scope="scope">
            <label>{{ format(scope.row.Recarga) }}</label>
          </template>
        </el-table-column>

        <el-table-column prop="Consumos" label="Consumos" width="100">
          <template slot-scope="scope">
            <label>
              {{ format(scope.row.Consumos) }}
            </label>
          </template>
        </el-table-column>

        <el-table-column prop="Balance" label="Balance" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.Balance > 0 ? 'success' : 'danger'">
              {{ format(scope.row.Balance) }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-pagination
        class="Pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage2"
        :page-sizes="[10, 200, 300, 400]"
        :page-size="10"
        layout="sizes, prev, pager, next"
        :total="registrosTotal"
      >
      </el-pagination>
    </el-row>
  </el-drawer>
</template>

<script>
export default {
  props: {
    Tarjeta: String,
    Dias: Number,
    Cliente: Number,
    Visible: Boolean
  },

  data() {
    return {
      valorDias: 40,
      tableData1: [],
      Loading: false,
      currentPage2: 1,
      totalDeRegistrosPorPagina: 10,
      paginaActual: 1,
      registrosTotal: 0,
      Valores: [
        {
          value: 60,
          Label: "Ultimos 60 Dias"
        },
        {
          value: 90,
          Label: "Ultimos 90 Dias"
        },
        {
          value: 120,
          Label: "Ultimos 120 Dias"
        },
        {
          value: 40000,
          Label: "Todos"
        }
      ],
      Valor: []
    };
  },

  methods: {
    handleSizeChange(val) {
      this.totalDeRegistrosPorPagina = val;
      this.GetData(this.Valor);
    },
    handleCurrentChange(val) {
      this.paginaActual = val;

      this.currentPage2 = this.paginaActual;
      this.GetData(this.Valor);
    },
    format(price) {
      return new Intl.NumberFormat("en-US").format(price);
    },
    ChangeDays() {
      this.paginaActual = 1;
      this.currentPage2 = this.paginaActual;
      this.GetData(this.Valor);
    },
    async GetData(Dias) {
      this.tableData1 = [];

      this.valorDias = Dias;
      this.Loading = true;
      await this.$http
        .get(`/api/tennos/GetTransanctionByCardId/`, {
          params: {
            Tarjetaid: this.Tarjeta,
            dias: this.valorDias,
            ClienteId: this.Cliente,
            Page: this.paginaActual,
            recordsPerPage: this.totalDeRegistrosPorPagina
          }
        })
        .then((resp) => {
          this.registrosTotal = resp.data.total;
          resp.data.transacciones.forEach((element) => {
            this.tableData1.push(element);
          });
          this.Loading = false;
        });
    }
  },

  watch: {
    Visible(val) {
      if (val) {
        this.GetData(this.Dias);
      } else {
        this.Valor = [];
        this.tableData1 = [];
      }
    }
  }
};
</script>

<style scoped>
.el-table td {
  width: 10px;
}
.cell {
  width: 1px;
}
.Table {
  margin: 0 auto;
  padding-left: 200px;
}
.Pagination {
  margin: 0 auto;
}
</style>
